import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal'
import { Link } from 'react-router-dom';
import { images } from '../../assets/images';

function Getin_touchmodal(props) {
    const [show, setShow] = useState(true);

  const handleClose = () => setShow(false);
  return (
    <>
       <Modal show={show} onHide={handleClose}  size="lg" aria-labelledby="contained-modal-title-vcenter"
      centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <div className='get_in_touch_wrap'>
              <div className='inner_area_get_in_touch'>
                <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                   <div className='left_area' style={{ backgroundImage: `url(${images.get_in_touch})` }}>
                        <div className="section_title both_line text-center"><h2>Get  In Touch</h2></div>
                          <div className='form_area_in'>
                            <Form>
                              <div className='row'>
                                  <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12'>
                                    <Form.Group className="form_controlers" controlId="exampleForm.ControlInput1">
                                      <Form.Control type="text" placeholder="Your Name" />
                                      <div className='icon'><i class="fas fa-user"></i></div>
                                    </Form.Group>
                                  </div>
                                  <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12'>
                                    <Form.Group className="form_controlers" controlId="exampleForm.ControlTextarea1">
                                      <Form.Control type="email" placeholder="Email Address" />
                                      <div className='icon'><i class="fas fa-envelope"></i></div>
                                    </Form.Group>
                                  </div>
                                  <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                                    <Form.Group className="form_controlers" controlId="exampleForm.ControlTextarea1">
                                      <Form.Control type="number" placeholder="Phone" />
                                      <div className='icon'><i class="fas fa-phone"></i></div>
                                    </Form.Group>
                                  </div>
                                  <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                                  <Form.Group className="form_controlers" controlId="exampleForm.ControlTextarea1">
                                    <Form.Control as="textarea" placeholder="Your Message" rows={3} />
                                    <div className='icon'><i class="fas fa-envelope-open"></i></div>
                                  </Form.Group>
                                  </div>
                                  <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                                        <div className='send_msg secondary_btn nav-item mx-auto'>
                                              <button type='submit' className='btn btn-outline-primary mx-auto d-block'>Send Message</button>
                                        </div>
                                  </div>
                                  <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                                       <div className='map'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15280114.312265644!2d73.72997399968845!3d20.77118574818321!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30635ff06b92b791%3A0xd78c4fa1854213a6!2sIndia!5e0!3m2!1sen!2sin!4v1656653923474!5m2!1sen!2sin"  loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                       </div>
                                  </div>
                              </div>
                            </Form>
                          </div>
                    </div>
                   <div className='right_area'>
                        <div className='contact'>
                             <div className='head'>
                                <h4>
                                  Contact Us
                                </h4>
                              </div>
                              <div className='reches_set'>
                                  <div className='left_areas'>
                                      <i class="fas fa-phone"></i>
                                  </div>
                                  <div className='right_areas'>
                                       <h6>
                                           Phone Number
                                       </h6>
                                       <a href='telto:8054964656'>
                                          +91 8054964656
                                       </a>
                                       <a href='telto:8968628088'>
                                          +91 8968628088
                                       </a>
                                  </div>
                              </div>
                              <div className='reches_set'>
                                  <div className='left_areas'>
                                      <i class="fas fa-map-marker-alt"></i>
                                  </div>
                                  <div className='right_areas'>
                                       <h6>
                                        Location
                                       </h6>
                                       <p>
                                        Tech Cruizers private Limited
                                        #123, Lorem ipsum Location,City,
                                        State, Country-123456
                                       </p>
                                  </div>
                              </div>
                              <div className='reches_set'>
                                  <div className='left_areas'>
                                      <i class="far fa-envelope"></i>
                                  </div>
                                  <div className='right_areas'>
                                       <h6>
                                          Email Address
                                       </h6>
                                       <a href='mailto:info@techcruizer.com'>
                                        info@techcruizer.com
                                       </a>
                                  </div>
                              </div>
                              <div className='social'>
                                <ul>
                                    <li>
                                      <Link to=""><i class="fab fa-facebook-f"></i></Link>
                                    </li>
                                    <li>
                                      <Link to=""><i class="fab fa-twitter"></i></Link>
                                    </li>
                                    <li>
                                      <Link to=""><i class="fab fa-instagram"></i></Link>
                                    </li>
                                    <li>
                                      <Link to=""><i class="fab fa-linkedin-in"></i></Link>
                                    </li>
                                </ul>
                              </div>
                        </div>
                   </div>
                </div>
              </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default Getin_touchmodal
